import React, { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Button, Card } from "@dune/ui";
import { AlertTriangle } from "lucide-react";
import { useGetPublicConstructionSiteForCompletion } from "../../api/queries/constructionSites.queries";
import ConstructionSiteQuizForm from "./components/ConstructionSiteQuizForm";

const ConstructionSiteCompletePage: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");

	const [showForm, setShowForm] = useState(false);

	const {
		data: constructionSiteData,
		isLoading,
		error: queryError,
	} = useGetPublicConstructionSiteForCompletion(Number(id || 0), token || "");

	const error = queryError ? "Lien invalide ou expiré" : null;

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gray-50">
				<div className="text-center">
					<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" />
					<p className="text-gray-600">Chargement...</p>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gray-50">
				<Card className="p-8 max-w-md mx-auto text-center">
					<AlertTriangle className="w-12 h-12 text-red-600 mx-auto mb-4" />
					<h1 className="text-xl font-semibold text-gray-900 mb-2">
						Erreur d'accès
					</h1>
					<p className="text-gray-600 mb-4">{error}</p>
					<p className="text-sm text-gray-500">
						Veuillez contacter votre apporteur pour obtenir un nouveau lien.
					</p>
				</Card>
			</div>
		);
	}

	if (!constructionSiteData) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gray-50">
				<Card className="p-8 max-w-md mx-auto text-center">
					<h1 className="text-xl font-semibold text-gray-900 mb-2">
						Chantier non trouvé
					</h1>
					<p className="text-gray-600">
						Le chantier demandé n'existe pas ou n'est plus accessible.
					</p>
				</Card>
			</div>
		);
	}

	if (!showForm) {
		return (
			<div className="h-screen  px-4 flex justify-center items-center bg-background-blue w-screen">
				<div className="absolute top-0 left-0 p-6">
					<img src="/dune_white_logo.png" alt="Dune Logo" className="w-32" />
				</div>
				<Card className="p-8 text-center max-w-2xl">
					<div className="mb-6">
						<h1 className="text-2xl font-bold text-gray-900 mb-2">
							Questionnaire assurance chantier
						</h1>
						<p className="text-gray-600">
							<strong>{constructionSiteData.brokerSociety.denomination}</strong>{" "}
							vous invite à compléter le questionnaire d'assurance à votre
							chantier.
						</p>
					</div>
					<Button
						onClick={() => setShowForm(true)}
						className="w-full"
						size="lg"
					>
						Commencer le questionnaire
					</Button>
				</Card>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gray-50">
			<ConstructionSiteQuizForm
				constructionSiteId={constructionSiteData.constructionSiteId}
				brokerSociety={constructionSiteData.brokerSociety}
				token={token || ""}
				onBack={() => setShowForm(false)}
			/>
		</div>
	);
};

export default ConstructionSiteCompletePage;
